import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';
import LinkedEntitiesCellBlock from '../../LinkedEntitiesCellBlock';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import { COST_ENV_CONFIG_KEYS, STATUS_COLOR_MAPPING } from './consts';
import getEnvConfig from './helpers/getEnvConfig';

const PcoLinkedEntitiesCellBlock = ({ entity, env, region, projectId, ...props }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  const { id, name: title, status, number } = entity;

  const statusColor = status ? STATUS_COLOR_MAPPING[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;
  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    COST_ENV_CONFIG_KEYS.COST_FE
  )}/projects/${projectId}/changeorders/pco?preview=${id}`;

  return (
    <LinkedEntitiesCellBlock
      entityTypeName={T.translate('PCO')}
      title={title}
      userFriendlyId={number}
      deeplinkUrl={deeplinkUrl}
      statusColor={statusColor}
      statusText={statusText}
      {...props}
    />
  );
};

PcoLinkedEntitiesCellBlock.propTypes = {
  /**
   * The PCO entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default PcoLinkedEntitiesCellBlock;
